import {useInjex} from '@injex/react-plugin';
import {RouterService} from '../services/routerService.mdl';

export default function useRouterService(): RouterService {
    const [inject] = useInjex();
    return inject<RouterService>('routerService');
}